(function () {
  function makeDotsAccessible(root) {
    var scope = root || document;

    // Flickity creates: <ol class="flickity-page-dots"><li class="dot ..."></li>...</ol>
    var dotGroups = scope.querySelectorAll('.flickity-page-dots');

    dotGroups.forEach(function (group) {
      var dots = group.querySelectorAll('li.dot');
      if (!dots.length) return;

      // Ensure the group itself has a label
      if (!group.getAttribute('aria-label')) {
        group.setAttribute('aria-label', 'Slideshow pagination');
      }

      dots.forEach(function (dot, i) {
        // Make the dot keyboard focusable and announce it like a button
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');

        // If Flickity already set aria-label, keep it. Otherwise add one.
        if (!dot.getAttribute('aria-label')) {
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        }

        // If Flickity marks selected dots, keep that reflected
        if (dot.classList.contains('is-selected')) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }

        // Keyboard support: Enter/Space should activate the dot
        dot.addEventListener('keydown', function (e) {
          var key = e.key;
          if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            dot.click();
          }
        });
      });
    });
  }

  // Run once on load
  document.addEventListener('DOMContentLoaded', function () {
    makeDotsAccessible(document);

    // Re-run whenever Flickity updates slides (it toggles is-selected)
    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('dot')) {
        // allow Flickity to update selection first
        setTimeout(function () { makeDotsAccessible(document); }, 0);
      }
    });

    // Catch slideshows injected/changed by theme editor
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) {
          makeDotsAccessible(document);
        }
        // Also update if class changes (is-selected toggles)
        if (m.type === 'attributes' && m.target && m.target.classList && m.target.classList.contains('dot')) {
          makeDotsAccessible(document);
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();
